<template>
  <Row class-name="c-condition">
    <Col span="24">
      <div class="c-condition-type">
        <RadioGroup v-model="requirement" type="button">
          <Radio label="anyone">任意条件</Radio>
          <Radio label="all">全部条件</Radio>
        </RadioGroup>
      </div>
    </Col>
    <Col span="24">
      <template v-for="(cond, idx) in conditions">
        <cond-item
          v-model="cond.value"
          :name="cond.key"
          :key="idx"
          :index="idx"
          :trash="trash"
          :current="cond.id"
          :equal="cond.expression"
          :dropmenu="dropmenu"
          :dropequal="cond.equalenums"
          :unit="cond.unit"
          :field-type="cond.field_type"
          :enum-property="cond.enum_property"
          :verify="verify"
          :fixed="cond.fixed"
          :precision="cond.precision"
          @on-delete="del(idx)"
          @on-change="upload"
        ></cond-item>
      </template>
    </Col>
    <Col span="24" v-if="addicon">
      <Button icon="md-add" class="c-add-btn" @click="append">增加条件</Button>
    </Col>
  </Row>
</template>
<script>
import CondItem from './cond-item.vue'
export default {
  name: 'condition',
  components: { CondItem },
  props: {
    value: {
      type: Array
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    satisfy: {
      type: String
    },
    verify: {
      type: Boolean
    },
    noinit: {
      type: Boolean
    },
    maxCond: {
      type: Number,
      default: 23
    }
  },
  computed: {
    conditions: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    trash() {
      return this.conditions.length > 1
    },
    dropmenu() {
      return this.data.map((ret) => {
        return {
          value: ret.id,
          label: ret.name
        }
      })
    },
    addicon() {
      return this.conditions.length < this.maxCond
    },
    requirement: {
      get() {
        return this.satisfy
      },
      set(val) {
        this.$emit('on-change', val)
      }
    }
  },
  methods: {
    append() {
      const cond = this.data.length && JSON.parse(JSON.stringify(this.data[0]))
      this.conditions.push(cond)
    },
    upload({ current, equal, index }) {
      const cond = this.data.filter((ret) => ret.id === current).pop()
      const condition = JSON.parse(JSON.stringify(cond))
      equal && (condition.expression = equal)
      equal === '==' && (condition.value = '0')
      this.conditions.splice(index, 1, condition)
    },
    del(index) {
      this.conditions.splice(index, 1)
    }
  },
  created() {
    !this.noinit && this.append()
  }
}
</script>
<style lang="scss" scoped>
.c-condition {
  min-width: 774px;

  .c-condition-type {
    margin-bottom: 20px;
  }

  .c-add-btn {
    margin-left: 0;
  }
}
</style>
